import { render, staticRenderFns } from "./BorrowingRecord.vue?vue&type=template&id=64e859dc&scoped=true&"
import script from "./BorrowingRecord.vue?vue&type=script&lang=js&"
export * from "./BorrowingRecord.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingRecord.vue?vue&type=style&index=0&id=64e859dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e859dc",
  null
  
)

export default component.exports